import parseToIntService from './../services/parseToInt.service'

const parseToInt = (key) => {
  return parseToIntService.parseToInt(key)
}

export default parseToInt
